import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Content from "../../common/Content";
import DifficultySelector from "../../ui/DifficultySelector";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import PenAcrobaticsLevel from "./PenAcrobaticsLevel";

export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    setStarted(false);
  }, [level]);

  const startGame = () => {
    setStarted(true);
  };

  return (
    <>
      <GameArea game={game}>
        <PenAcrobaticsLevel started={started} level={level}/>
      </GameArea>

      <Content>
        <div>{started ? <></> : <PlayButton onClick={startGame} />}</div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
            setStarted(false);
          }}
          levels={3}
          current={level}
        />
      </Content>
    </>
  );
};
